import React from "react";
import F1 from "../../assets/12_Quienes somos/Astara/wearemobilidad-cardgrid-1.webp";
import F2 from "../../assets/12_Quienes somos/Astara/wearemobilidad-cardgrid-2.webp";
import F3 from "../../assets/12_Quienes somos/Astara/wearemobilidad-cardgrid-3.webp";
import F4 from "../../assets/12_Quienes somos/Astara/wearemobilidad-cardgrid-4.webp";

/*eslint-disable */

declare const window: any;
const CulturaComponent: React.FC = () => {
  return (
    <div className="astara-cultura">
      {/* H2 - Título principal de la sección */}
      <h2 className="title">Una cultura muy abierta</h2>
      
      {/* H3 - Descripción principal */}
      <h3 className="description">Nuestros valores nos guían para acompañarte siempre, sea cual sea tu necesidad. Somos…</h3>
      
      <div className="contenido row">
        <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
          <div className="item-cultura" style={{ backgroundImage: `url(${F1})` }}>
            {/* H4 - Título del valor */}
            <h4 className="title-item-cultura">Innovadores</h4>
            {/* H5 - Descripción del valor */}
            <h5 className="description-item-cultura">Miramos de frente a las oportunidades de movilidad gracias a la tecnología y a la inteligencia de datos.</h5>
          </div>
        </div>
        
        <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
          <div className="item-cultura" style={{ backgroundImage: `url(${F2})` }}>
            {/* H4 - Título del valor */}
            <h4 className="title-item-cultura">Humanos</h4>
            {/* H5 - Descripción del valor */}
            <h5 className="description-item-cultura">Nada sirve si no conseguimos conectar contigo y con tus formas de moverte. Tú te mueves, y nosotros te seguimos.</h5>
          </div>
        </div>
        
        <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
          <div className="item-cultura" style={{ backgroundImage: `url(${F3})` }}>
            {/* H4 - Título del valor */}
            <h4 className="title-item-cultura">Valientes</h4>
            {/* H5 - Descripción del valor */}
            <h5 className="description-item-cultura">La valentía nace de un impulso. Es nuestro instinto para seguir avanzando a pesar de los retos de hoy y del futuro.</h5>
          </div>
        </div>
        
        <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
          <div className="item-cultura" style={{ backgroundImage: `url(${F4})` }}>
            {/* H4 - Título del valor */}
            <h4 className="title-item-cultura">Abiertos</h4>
            {/* H5 - Descripción del valor */}
            <h5 className="description-item-cultura">Escuchamos con curiosidad a nuestros clientes, empleados, socios y accionistas. Y lo hacemos de verdad.</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CulturaComponent;